import { TrendingUp, GitBranch, Cpu, Blocks } from "lucide-react";

const LearningPillars = () => {
  return (
    <section id="learning-pillars" data-testid="learning-pillars-section" className="section-primary">
      <div className="section-glow top-left" style={{ right: '-200px', left: 'auto' }}></div>
      <div className="section-glow bottom-right" style={{ left: '-200px', right: 'auto' }}></div>
      
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Learning Pillars</h2>
          <div className="section-divider"></div>
        </div>
        
        <div className="pillar-grid">
          {/* Card 1 - Market Understanding */}
          <div className="pillar-card" data-testid="pillar-card-0">
            <div className="pillar-card-image">
              <img src="https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=800&q=80" alt="Market Understanding" />
              <div className="pillar-card-image-overlay"></div>
              <div className="pillar-card-icon">
                <TrendingUp />
              </div>
            </div>
            <div className="pillar-card-content">
              <h3 className="pillar-card-title">Market Understanding</h3>
              <ul className="pillar-card-list">
                <li><span></span><span>How modern trading environments function</span></li>
                <li><span></span><span>Volatility, probability, and uncertainty</span></li>
                <li><span></span><span>Behavior, discipline, and decision quality</span></li>
              </ul>
            </div>
            <div className="pillar-card-hover"></div>
          </div>

          {/* Card 2 - Structured Decision Frameworks */}
          <div className="pillar-card" data-testid="pillar-card-1">
            <div className="pillar-card-image">
              <img src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&q=80" alt="Decision Frameworks" />
              <div className="pillar-card-image-overlay"></div>
              <div className="pillar-card-icon">
                <GitBranch />
              </div>
            </div>
            <div className="pillar-card-content">
              <h3 className="pillar-card-title">Structured Decision Frameworks</h3>
              <ul className="pillar-card-list">
                <li><span></span><span>Rule-based thinking over impulse</span></li>
                <li><span></span><span>Preparation, execution, and review loops</span></li>
                <li><span></span><span>Process-driven improvement</span></li>
              </ul>
            </div>
            <div className="pillar-card-hover"></div>
          </div>

          {/* Card 3 - AI & Technology */}
          <div className="pillar-card" data-testid="pillar-card-2">
            <div className="pillar-card-image">
              <img src="https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800&q=80" alt="AI Technology" />
              <div className="pillar-card-image-overlay"></div>
              <div className="pillar-card-icon">
                <Cpu />
              </div>
            </div>
            <div className="pillar-card-content">
              <h3 className="pillar-card-title">AI & Technology Awareness</h3>
              <ul className="pillar-card-list">
                <li><span></span><span>Understanding AI-assisted trading tools</span></li>
                <li><span></span><span>Interpreting outputs with human oversight</span></li>
                <li><span></span><span>Limits and responsibilities of automation</span></li>
              </ul>
            </div>
            <div className="pillar-card-hover"></div>
          </div>

          {/* Card 4 - Web3 */}
          <div className="pillar-card" data-testid="pillar-card-3">
            <div className="pillar-card-image">
              <img src="https://images.unsplash.com/photo-1639762681485-074b7f938ba0?w=800&q=80" alt="Web3 Digital Assets" />
              <div className="pillar-card-image-overlay"></div>
              <div className="pillar-card-icon">
                <Blocks />
              </div>
            </div>
            <div className="pillar-card-content">
              <h3 className="pillar-card-title">Web3 & Digital Asset Context</h3>
              <ul className="pillar-card-list">
                <li><span></span><span>Blockchain fundamentals</span></li>
                <li><span></span><span>Practical use cases</span></li>
                <li><span></span><span>Ethical ecosystem participation</span></li>
              </ul>
            </div>
            <div className="pillar-card-hover"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LearningPillars;
